// extracted by mini-css-extract-plugin
export default {"wrapper":"membership_wrapper__JO-eE","walletIcon":"membership_walletIcon__DdTjL"};